import SmsVerification from './sms-verification-container';
import SmsVerificationView from './sms-verification-view';

export default SmsVerification;
export { SmsVerificationView };
